<!--  -->
<template>
  <a-form-item v-if="element" :key="element.key" :label="element.label" :name="element.model">
    <template v-if="element.type === 'input'">
      <a-input
        v-model:value="element.options.defaultValue"
        :size="config.size"
        :style="{ width: element.options.width }"
        :placeholder="element.options.placeholder"
        :maxlength="parseInt(element.options.maxlength)"
        :prefix="element.options.prefix"
        :suffix="element.options.suffix"
        :addonBefore="element.options.addonBefore"
        :addonAfter="element.options.addonAfter"
        :allowClear="element.options.allowClear"
        :readonly="element.options.readonly"
        :disabled="disabled"
      />
    </template>
    <template v-if="element.type === 'textarea'">
      <a-textarea
        style="resize: none"
        v-model:value="element.options.defaultValue"
        :size="config.size"
        :rows="element.options.rows"
        :style="{ width: element.options.width }"
        :placeholder="element.options.placeholder"
        :maxlength="element.options.maxlength"
        :showCount="element.options.showCount"
        :autoSize="element.options.autoSize"
        :allowClear="element.options.allowClear"
        :readonly="element.options.readonly"
        :disabled="disabled"
      />
    </template>
    <template v-if="element.type === 'radio'">
      <a-radio-group
        v-model:value="element.options.defaultValue"
        :size="config.size"
        :style="{ width: element.options.width }"
        :disabled="disabled"
      >
        <a-radio
          v-for="item of element.options.remote
            ? element.options.remoteOptions
            : element.options.options"
          :key="item.value"
          :value="item.value"
          :style="{
            display: element.options.inline ? 'inline-block' : 'block',
          }"
          @focus="radioFocus(item)"
        >
          {{item.label}}
          <a-input
            v-model:value="item.label"
            style="width: 100px; margin-left: 10px"
            v-if="item.selected"
            @blur="radioBlur(item)"
          />
        </a-radio>
      </a-radio-group>
    </template>
    <template v-if="element.type === 'checkbox'">
      <a-checkbox-group
        v-model:value="element.options.defaultValue"
        :style="{ width: element.options.width }"
        :disabled="disabled"
      >
        <a-checkbox
          v-for="item of element.options.remote
            ? element.options.remoteOptions
            : element.options.options"
          :key="item.value"
          :value="item.value"
          @focus="checkBoxFocus(item)"
          :style="{
            display: element.options.inline ? 'inline-block' : 'block'
          }"
        >
          {{item.label}}
          <a-input
            v-model:value="item.label"
            style="width: 100px; margin-left: 10px"
            v-if="item.selected"
            @blur="checkBoxBlur(item)"
          />
        </a-checkbox>
      </a-checkbox-group>
    </template>

    <template v-if="element.type === 'time'">
      <a-date-picker
        :size="config.size"
        v-model:value="element.options.defaultValue"
        :placeholder="element.options.placeholder"
        :inputReadOnly="element.options.readonly"
        :allowClear="element.options.allowClear"
        :format="element.options.format"
        :disabled="disabled"
        :style="{ width: element.options.width }"
      />
    </template>
    <!-- :disabled="element.options.disabled" -->
    <template v-if="element.type === 'upload'">
      <a-upload
        class="upload"
        :name="element.options.file"
        action="/api/ces/upload"
        :accept="element.options.accept"
        :file-list="element.options.fileList"
        listType="picture"
        :multiple="element.options.multiple"
        :disabled="disabled"
        @change="(file,fileList,event) => {
          handleUploadChange(element,file,fileList,event)
        }"
        v-model:file-list="element.options.fileList"
      >
        <a-button class="upload-btn">
          <Icon :icon="'upload-cloud-2-line'" />
          <p>点击上传</p>
        </a-button>
      </a-upload>
    </template>
  </a-form-item>
</template>

<script>
import { defineComponent, computed, onMounted } from "vue";
import Icon from "@/layout/icon";
import { useRoute } from "vue-router";
// 导入的其他文件 例如：import moduleName from 'modulePath';

export default defineComponent({
  name: "generateFormItem",
  components: {
    Icon
  },
  props: {
    config: {
      type: Object,
      required: true
    },
    element: {
      type: Object,
      required: true
    },
    model: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean
    }
  },
  emits: ["update:model"],
  setup(props, context) {
    // const data = computed({
    //   get: () => {
    //     console.log(props.element.model, "props.element.model");
    //     props.model[props.element.model];
    //   },
    //   set: val => {
    //     const model = JSON.parse(JSON.stringify(props.model));
    //     model[props.element.model] = val;
    //     context.emit("update:model", model);
    //   }
    // });
    const handleUploadChange = (element, file, fileList, event) => {
      file.fileList.forEach(item => {
        if (item.response) {
          item.thumbUrl = item.response.url;
        }
      });
      // 限制只能传一个
      element.options.fileList = file.fileList.slice(-1);
    };
    const radioFocus = item => {
      console.log(item, "item");
      item.selected = true;
    };
    const radioBlur = item => {
      console.log(item, "radioBlur");
      item.selected = false;
    };
    const checkBoxFocus = item => {
      item.selected = true;
    };
    const checkBoxBlur = item => {
      item.selected = false;
    };

    return {
      handleUploadChange,
      radioFocus,
      radioBlur,
      checkBoxFocus,
      checkBoxBlur
    };
  }
});
</script>
<style lang="less">
.configForm .ant-col {
  width: 15%;
}
.configForm .ant-form-item-control-wrapper {
  flex: 1 !important;
}
.configForm .ant-form-item-control {
  height: 100%;
}
.configForm .ant-form-item-control .ant-form-item-children {
  height: 100%;
  #flex-box.row-start-c();
  width: 100%;
}
.configForm .ant-form-item-control .ant-form-item-children .ant-radio-group,
.ant-checkbox-group {
  height: 100%;
  #flex-box.column-start-start();
  width: 100%;
}
.configForm
  .ant-form-item-control
  .ant-form-item-children
  .ant-checkbox-wrapper {
  margin-left: 0 !important;
}
textarea.ant-input {
  margin-top: 10px;
}
.ant-upload .ant-btn {
  #flex-box.row-start-c();
  margin-top: 5px;
}
.upload .ant-upload-list-item-info {
  padding: 0 12px 0 4px !important;
}
</style>
<style lang='less' scoped>
//@import url(); 引入公共css类
.upload-btn {
  width: 100px;
  #flex-box.row-c-c();
}
.upload {
  #flex-box.column-start();
}
</style>